document.addEventListener('DOMContentLoaded', () => {
  // Helper Function to Wait for Elements
  function waitForElements(selector, callback) {
    const interval = setInterval(() => {
      if (document.querySelector(selector)) {
        clearInterval(interval);
        callback();
      }
    }, 100); // Check every 100ms
  }

  // Functions to Disable and Enable Scrolling
  function disableScroll() {
    document.body.style.overflow = 'hidden';
    document.getElementById('modalOverlay').style.display = 'block';
  }

  function enableScroll() {
    document.body.style.overflow = '';
    document.getElementById('modalOverlay').style.display = 'none';
  }

  // Wait for the Relevant Elements to be Loaded
  waitForElements('.highlight-link', () => {
    // Open Information Cards
    document.querySelectorAll('.highlight-link-2').forEach(link => {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        const targetId = this.getAttribute('data-target');
        document.getElementById(targetId).style.display = 'block';
        disableScroll();
      });
    });

    // Close Information Cards
    document.querySelectorAll('.close-button-1, .close-button-2, .close-button-3, .close-button-4').forEach(button => {
      button.addEventListener('click', function() {
        this.closest('.info-card-1, .info-card-2, .info-card-3, .info-card-4').style.display = 'none';
        enableScroll();
      });
    });

    // Smooth Scroll and Close Info Card
    document.querySelectorAll('.cta-button, .cta-button-1, .cta-button-2, .cta-button-3, .cta-button-4').forEach(button => {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth'
          });
        }

        const infoCard = this.closest('.info-card-1, .info-card-2, .info-card-3, .info-card-4');
        if (infoCard) {
          infoCard.style.display = 'none';
          enableScroll();
        }
      });
    });

    // Expi Benefits Swipe Functionality
    let currentIndex = 0;
    const cards = document.querySelectorAll('.expi-benefits .swipe-card');
    const dots = document.querySelectorAll('.expi-benefits .dots img');

    function updateSwipeCard(index) {
      cards.forEach((card, i) => {
        card.style.display = i === index ? 'block' : 'none';
        dots[i].src = i === index
          ? 'https://cdn.shopify.com/s/files/1/2443/2395/files/Card_Swipe_Dots_-_Active.png?v=1717616863'
          : 'https://cdn.shopify.com/s/files/1/2443/2395/files/Card_Swipe_Dots_-_Inactive.png?v=1717616863';
      });
    }

    // document.getElementById('swipeRight').addEventListener('click', function() {
    //   currentIndex = (currentIndex + 1) % cards.length;
    //   updateSwipeCard(currentIndex);
    // });

    // document.getElementById('swipeLeft').addEventListener('click', function() {
    //   currentIndex = (currentIndex - 1 + cards.length) % cards.length;
    //   updateSwipeCard(currentIndex);
    // });

    updateSwipeCard(currentIndex); // Initialize the first card display

    // Reco By Swipe Functionality
    let currentIndexReco = 0;
    const cardsReco = document.querySelectorAll('.reco-by .swipe-card');
    const dotsReco = document.querySelectorAll('.reco-by .dots img');

    function updateSwipeCardReco(index) {
      cardsReco.forEach((card, i) => {
        card.style.display = i === index ? 'block' : 'none';
        dotsReco[i].src = i === index
          ? 'https://cdn.shopify.com/s/files/1/2443/2395/files/Card_Swipe_Dots_-_Active.png?v=1717616863'
          : 'https://cdn.shopify.com/s/files/1/2443/2395/files/Card_Swipe_Dots_-_Inactive.png?v=1717616863';
      });
    }

    document.getElementById('swipeRightReco').addEventListener('click', function() {
      currentIndexReco = (currentIndexReco + 1) % cardsReco.length;
      updateSwipeCardReco(currentIndexReco);
    });

    document.getElementById('swipeLeftReco').addEventListener('click', function() {
      currentIndexReco = (currentIndexReco - 1 + cardsReco.length) % cardsReco.length;
      updateSwipeCardReco(currentIndexReco);
    });

    updateSwipeCardReco(currentIndexReco); // Initialize the first card display

    // Touch Swipe for "Reco By" Section
    const cardContainer = document.querySelector('.swipe-card-container');
    let startX, isDown = false;

    cardContainer.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX;
    });

    cardContainer.addEventListener('mouseup', (e) => {
      if (!isDown) return;
      isDown = false;
      const moveX = e.pageX - startX;
      if (moveX > 100) {
        document.getElementById('swipeLeftReco').click();
      } else if (moveX < -100) {
        document.getElementById('swipeRightReco').click();
      }
    });

    cardContainer.addEventListener('touchstart', (e) => {
      isDown = true;
      startX = e.touches[0].pageX;
    });

    cardContainer.addEventListener('touchend', (e) => {
      if (!isDown) return;
      isDown = false;
      const moveX = e.changedTouches[0].pageX - startX;
      if (moveX > 100) {
        document.getElementById('swipeLeftReco').click();
      } else if (moveX < -100) {
        document.getElementById('swipeRightReco').click();
      }
    });
  });
});
